import { Tag, Tooltip } from "antd"
import styled from "styled-components"

import Flex from "#blocks/Flex"
import { type Hexcode } from "#contexts/ThemeContextProvider"
import { type ReactChild } from "#customTypes/globalTypes"

const SIcon = styled(Flex)<{ color: Hexcode }>`
  height: 12px;
  width: 12px;
  color: ${({ color }) => color};
`

const IconBadge = ({
  color,
  icon,
  text,
  tooltip,
  backgroundColor,
}: {
  color: Hexcode
  icon: ReactChild
  text: string | number
  tooltip?: string | ReactChild
  backgroundColor?: Hexcode
}) => {
  let Content = (
    <Flex gap={5} center style={{ width: "fit-content" }}>
      <SIcon color={color}>{icon}</SIcon>
      <div style={{ color }}>{text}</div>
    </Flex>
  )

  if (backgroundColor) {
    Content = (
      <Tag
        color={backgroundColor}
        style={{
          width: "fit-content",
        }}
      >
        {Content}
      </Tag>
    )
  }

  if (tooltip) {
    Content = <Tooltip title={tooltip}>{Content}</Tooltip>
  }

  return Content
}

export default IconBadge
